import { AccountInfo } from "@azure/msal-browser";
import { createContext } from "react";

export interface AuthContextType {
  login: () => Promise<boolean>;
  logout: () => Promise<boolean>;
  clearSession: () => void; // Agregar este método
  user: AccountInfo | null;
}
export const AuthContext = createContext<AuthContextType | undefined>(
  undefined,
);
